import { SectionHeader } from "../../SectionHeader";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import TiltMessage from "../../../components/feedback/TiltMessage";
import { useMemo, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import { format } from "date-fns";
import { MonthYearPicker } from "../../ui/month-Year-Picker";
import { ManagerialMetrics } from "../components/ecom-metrics";
/* import EcomRevenue from "../components/ecom-revenue"; */
import { EcommMultiChannel } from "../components/ecom-multichannel";
import { EcommRevenueOverview } from "../components/ecomm-accounting-rev";
import { EcommExpenseReport } from "../components/ecomm-ExpenseReport";
import { EcommCategoryPerformance } from "../components/ecomm-categoryPerformance";
import { EcommAOVFrequency } from "../components/eccom-AOV";
import { EcomRevenueChart } from "../components/ecomm-revenueBreakdown";
import { EcommGenderCategory } from "../components/eccom-GenderCategory";
import { EcommCollectionPerformance } from "../components/eccom-collectionPerformance";
import { EcommColorPerformance } from "../components/eccom-colorPerformance";
import { EcommSizePerformance } from "../components/eccom-sizePerformance";
import { EcommSKUPerformance } from "../components/eccom-skuPerformance";
import { EcommShopifyTopProducts } from "../components/eccom-ShopifyTopProducts";
import { Card } from "../../ui/card";
import { SummaryHeader } from "../../ui/SummaryHeader";
import { EcommCompletePerformance } from "../components/eccom-shopifyPerfomanceTable";
import { TriangleAlert } from "lucide-react";


export function ECommercePage() {
    const now = new Date();
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date(now.getFullYear(), now.getMonth()));
    const formattedDate = selectedDate ? format(selectedDate, "yyyy-MM") : "";
    const [categorySelectedDate, setCategorySelectedDate] = useState<Date | undefined>(new Date(now.getFullYear(), now.getMonth()));
    const categoryFormattedDate = categorySelectedDate ? format(categorySelectedDate, "yyyy-MM") : "";
    const showTiltMessage = useIsPortraitMobile();

    const isCurrentMonthIncomplete = useMemo(() => {
        if (!selectedDate) return false;
        const selectedMonthStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        const selectedMonthEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
        return now >= selectedMonthStart && now <= selectedMonthEnd && now.getDate() < selectedMonthEnd.getDate();
    }, [selectedDate, now]);

    return (
        <div>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="E-Commerce" />
                <div className="flex flex-row items-center justify-between">
                <div className="mb-4">
                    <MonthYearPicker selected={selectedDate} onChange={setSelectedDate} />
                </div>
                {isCurrentMonthIncomplete && (
                        <div className="text-sm text-yellow-200 bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft px-3 py-2 flex flex-row items-center">
                            <TriangleAlert /> The current month is incomplete.
                        </div>
                    )}
                    </div>

                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <ManagerialMetrics selectedMonth={formattedDate} />
                    </div>
                    {/* <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                        <EcomRevenue selectedMonth={formattedDate} />
                    </div> */}
                    <div className="col-span-6 flex flex-col h-full">
                        <EcomRevenueChart />
                    </div>

                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                        <EcommRevenueOverview />
                    </div>
                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                        <EcommExpenseReport />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommMultiChannel />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommShopifyTopProducts selectedMonth={formattedDate} />
                    </div>

                    <div className="col-span-6 flex flex-col h-full">
                        <SummaryHeader
                            title="Category Performance"
                        />
                        <Card>
                            <Tabs defaultValue="general">
                               <div className="flex justify-between items-center w-full">
                                <TabsList className="m-4">
                                    <TabsTrigger value="general">General</TabsTrigger>
                                    <TabsTrigger value="gender">Gender</TabsTrigger>
                                    <TabsTrigger value="collection">Collection</TabsTrigger>
                                    <TabsTrigger value="size">Size</TabsTrigger>
                                    <TabsTrigger value="color">Color</TabsTrigger>
                                    <TabsTrigger value="sku">SKU</TabsTrigger>
                                </TabsList>
                                <div className="pr-3"><MonthYearPicker selected={categorySelectedDate} onChange={setCategorySelectedDate} /></div>
                                </div> 

                                <TabsContent value="general">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommCategoryPerformance selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                                <TabsContent value="gender">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommGenderCategory selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                                <TabsContent value="collection">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommCollectionPerformance selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                                <TabsContent value="size">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommSizePerformance selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                                <TabsContent value="color">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommColorPerformance selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                                <TabsContent value="sku">
                                    <div className="col-span-12 sm:col-span-6 2xl:col-span-3 flex flex-col h-full">
                                        <EcommSKUPerformance selectedMonth={categoryFormattedDate} />
                                    </div>
                                </TabsContent>
                            </Tabs>
                        </Card>
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommCompletePerformance selectedMonth={formattedDate} />
                    </div>
                    
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommAOVFrequency />
                    </div>
                    {/* <div className="col-span-6 flex flex-col h-full">
                        <EccomSalesCategoryPerformance selectedMonth={formattedDate} />
                    </div> */}
                </ModuleGrid>
            </div>
        </div>
    );
}